import { render, staticRenderFns } from "./navbar-router.vue?vue&type=template&id=25fcc384&"
import script from "./navbar-router.vue?vue&type=script&lang=js&"
export * from "./navbar-router.vue?vue&type=script&lang=js&"
import style0 from "./navbar-router.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./navbar-router.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports